import React, { useState, useEffect } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { EditOrderHistory } from "../ManageWholesaler/editOrdersHistory/editOrder";
import { EditSubUsers } from "../ManageWholesaler/editSubUsers/editSubUsers";
import { RetailerEditPersonal } from "./retailerEditPersonal";
import { RetailerOrderEdit } from "./editRetailerOrderHistory/retailerOrderEdit";
import { RetailerSubUser } from "./editRetailerSubUsers/retailerSubuser";
import { EditBusinessDocuments } from "./editBusinessDocuments";
import { axiosInstance } from "../../axiosInstance";

export function EditRetailer() {
  const { id } = useParams();
  console.log(id);

  const [retailerDetails, setRetailerDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const RetailerUserName = localStorage.getItem("retailer_username");
  console.log("Retailer Username:", RetailerUserName);

  const fetchWholesalers = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(`/admin/retailer-list/${id}`);
      console.log("✅ retailer details response:", res.data);
      if (res.data.status === "success") {
        setRetailerDetails(res.data.data || []);
      } else {
        setError("Failed to fetch retailer data.");
      }
    } catch (err) {
      console.error("❌ Error fetching retailer data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWholesalers();
  }, []);

  // const [label, setLabel] = useState("File upload.pdf ");
  // function handleLabel(e) {
  //   setLabel(e.target.files[0]?.name || "File upload.pdf");

  // }
  const [content, setContent] = useState(<RetailerEditPersonal id={id} />);
  const [activeEdit, setactiveEdit] = useState("personal");
  function handlePersonalDetails() {
    return <RetailerEditPersonal id={id} />;
  }
  function handleOrderHistory() {
    return <RetailerOrderEdit id={id} />;
  }
  function handleSubUsers() {
    return <RetailerSubUser RetailerUserName={RetailerUserName} id={id} />;
  }

  // function handleBusinessDocuments() {
  //   return <EditBusinessDocuments id={id} />;
  // }

  return (
    <div className="editWholesaler-container ">
      <div className="arrowNavigation">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/manage-retailer")}
        />
        <div>
          {retailerDetails?.retailers?.business_name || "Business Name"}
        </div>
        <div>Retailer ID: #{retailerDetails?.username || "N/A"}</div>
      </div>
      <div className="wholesalerMenu">
        <div
          onClick={() => {
            setContent(handlePersonalDetails);
            setactiveEdit("personal");
          }}
          className={`edit-menu ${
            activeEdit === "personal" ? "activeEdit" : ""
          }`}
        >
          Personal Details
        </div>
        {/* <div
          onClick={() => {
            setContent(handleBusinessDocuments);
            setactiveEdit("businessDocuments");
          }}
          className={`edit-menu ${
            activeEdit === "businessDocuments" ? "activeEdit" : ""
          }`}
        >
          Business Documents
        </div> */}
        <div
          onClick={() => {
            setContent(handleOrderHistory);
            setactiveEdit("orders");
          }}
          className={`edit-menu ${activeEdit === "orders" ? "activeEdit" : ""}`}
        >
          Orders History
        </div>
        <div
          onClick={() => {
            setContent(handleSubUsers);
            setactiveEdit("subusers");
          }}
          className={`edit-menu ${
            activeEdit === "subusers" ? "activeEdit" : ""
          }`}
        >
          Sub Users
        </div>
      </div>
      <div>{content}</div>
    </div>
  );
}
